export default function promiseRetry<T>(
  fn: () => Promise<T>,
  retries = 2,
  delayMS = 0,
): Promise<T> {
  return new Promise((res, rej) =>
    fn()
      .then(res)
      .catch(err => {
        if (retries === 0) {
          rej(err);
        } else {
          setTimeout(() => {
            promiseRetry(fn, retries - 1, delayMS).then(res, rej);
          }, delayMS);
        }
      }),
  );
}
